import React, { useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
// import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";

import {
  GAUsersTableHeadCells,
  GeneralAdminRoutes,
  getComparator,
  stableSort,
} from "../../../../../constants";
import { GAUsersTableRow } from "../components";
import TablePaginationSection from "../../../../../common/TablePaginationSection";
import { useUsersContext } from "../../../../../providers/OrganizationAdmin/UsersProvider";
import CommonTableHead from "../../../../../common/CommonTableHead";

export default function GAUsersTable({ selected, setSelected, allUsers }) {
  const {
    order,
    setOrder,
    orderBy,
    setOrderBy,
    page,
    setPage,
    rowsPerPage,
    setRowsPerPage,
  } = useUsersContext();
  const navigate = useNavigate();

  // Initialize column widths based on GAUsersTableHeadCells
  const initializeColumnWidths = () => {
    const widths = {};
    GAUsersTableHeadCells.forEach(cell => {
      widths[cell.id] = cell.width || 150;
    });
    return widths;
  };

  const [columnWidths, setColumnWidths] = useState(initializeColumnWidths);

  const handleColumnResize = (columnId, newWidth) => {
    setColumnWidths(prev => ({
      ...prev,
      [columnId]: newWidth
    }));
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const isSelected = (id) => selected.indexOf(id) !== -1;

  // Avoid a layout jump when reaching the last page with empty rows.
  const emptyRows =
    page - 1 > 0
      ? Math.max(0, (1 + page - 1) * rowsPerPage - allUsers.length)
      : 0;

  const visibleRows = useMemo(
    () =>
      stableSort(allUsers, getComparator(order, orderBy)).slice(
        (page - 1) * rowsPerPage,
        (page - 1) * rowsPerPage + rowsPerPage
      ),
    [order, orderBy, page, rowsPerPage, allUsers]
  );

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelected = visibleRows.map((n) => n.id);
      // const newSelected = allUsers.map((n) => n.id);
      setSelected(newSelected);
      return;
    }
    setSelected([]);
  };

  const handleClickRow = (event, id) => {
    const selectedIndex = selected.indexOf(id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }
    setSelected(newSelected);
  };

  const handleChangePage = (event, newPage) => {
    console.log(newPage);
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(1);
  };

  return (
    <Box sx={mainBoxContainerStyles}>
      <Paper sx={tablePaperContainerStyles}>
        <TableContainer
          style={{ border: "none", boxShadow: "none", maxHeight: "65vh" }}
        >
          <Table
            // sx={{ minWidth: 750 }}
            stickyHeader
            aria-label="sticky table"
            // aria-labelledby="tableTitle"
          >
            <CommonTableHead
              numSelected={selected.length}
              order={order}
              orderBy={orderBy}
              onSelectAllClick={handleSelectAllClick}
              onRequestSort={handleRequestSort}
              rowCount={visibleRows.length}
              tableHeadCells={GAUsersTableHeadCells}
              columnWidths={columnWidths}
              onColumnResize={handleColumnResize}
            />
            <TableBody>
              {visibleRows.map((row, index) => {
                const isItemSelected = isSelected(row?.id);
                const labelId = `enhanced-table-checkbox-${index}`;
                const numberType = index % 2 == 0;

                return (
                  <GAUsersTableRow
                    isItemSelected={isItemSelected}
                    row={row}
                    handleClickRow={handleClickRow}
                    numberType={numberType}
                    labelId={labelId}
                    key={index}
                    columnWidths={columnWidths}
                    handleNavigateToDetails={() => {
                      navigate(GeneralAdminRoutes.userDetails, {
                        state: { userDetails: row },
                      });
                      // navigate(GeneralAdminRoutes.userDetails, {
                      //   state: { userDetails: row },
                      // });
                    }}
                  />
                );
              })}
              {emptyRows > 0 && (
                <TableRow
                  style={{
                    height: 53 * emptyRows,
                  }}
                >
                  <TableCell colSpan={6} />
                </TableRow>
              )}

              {visibleRows.length === 0 && (
                <TableRow>
                  <TableCell colSpan={7} align="center">
                    No results found
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
      <TablePaginationSection
        count={Math.ceil(allUsers.length / rowsPerPage)}
        page={page}
        total={allUsers.length ?? 0}
        onPageChange={handleChangePage}
        rowsPerPage={rowsPerPage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </Box>
  );
}

// const boxContainerStyles = {
//   width: "100%",
//   paddingRight: 1,
//   border: "none",
//   boxShadow: "none",
//   // marginTop: 2,
// };

// const paperContainerStyles = {
//   // width: "100%",
//   // mb: 1,
//   // border: "none",
//   // boxShadow: "none",
//   // height: "67vh",
//   maxWidth: "100%",
//   mb: 1,
//   border: "none",
//   boxShadow: "none",
//   mt: 1,
//   overflow: "hidden",
//   height: "67vh",
// };

const mainBoxContainerStyles = {
  width: "100%",
  paddingRight: 1,
  border: "none",
  boxShadow: "none",
  // marginTop: 2,
};

const tablePaperContainerStyles = {
  // width: "100%",
  // mb: 2,
  // border: "none",
  // boxShadow: "none",
  // height: "67vh",
  maxWidth: "100%",
  mb: 1,
  border: "none",
  boxShadow: "none",
  mt: 1,
  overflow: "hidden",
  height: "67vh",
};
